





























import Vue from 'vue';
import * as ex from 'expangine-runtime';
import { LiveRuntime } from 'expangine-runtime-live';
import { Preferences } from './app/Preference';
import { Shortcuts } from './app/Shortcuts';
import Registry from './runtime';



export default Vue.extend({
  name: 'App',
  async mounted() {
    (window as any).registry = Registry;
    (window as any).runtime = LiveRuntime;
    (window as any).home = this;
    (window as any).ex = ex;
    (window as any).Shortcuts = Shortcuts;
    (window as any).Preference = Preferences;

    LiveRuntime.objectSet = (target, key, value) => {
      Vue.set(target as any, key as string, value);
    };
    LiveRuntime.objectRemove = (target, key) => {
      Vue.delete(target as any, key as string);
    };
    LiveRuntime.arraySet = (arr, index, item) => {
      const existing = arr[index];
      Vue.set(arr, index, item);
      return existing;
    };
    LiveRuntime.arrayRemoveAt = (arr, index) => {
      const existing = arr[index];
      Vue.delete(arr, index);
      return existing;
    };
  },
});
